export const agentCashTxnTypes = {
  withdraw: 'withdraw',
  transfer: 'transfer',
  adjust: 'adjust',
}
